function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
var _ref = /*#__PURE__*/React.createElement("defs", null);
var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "Time",
  className: "cls-1",
  d: "M7,0a7,7,0,1,0,7,7A7,7,0,0,0,7,0Zm3.15,8.4H7.006a.9.9,0,0,1-.875-.875V3.509a.875.875,0,0,1,1.75,0V6.646H10.15a.875.875,0,0,1,0,1.75Z"
});
var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    id: "BeBold",
    viewBox: "0 0 14 14"
  }, props), _ref, _ref2);
};
export default __webpack_public_path__ + "static/media/time.ed1c2184.svg";
export { SvgComponent as ReactComponent };